import httpClient from './httpClient'

export default {
  async getOrganization() {
    let ret = await httpClient.get('organizations')
    return ret
  },
  async getOrganizationPermissions() {
    let ret = await httpClient.get('permissions')
    return ret
  },
  async getRolePermissionsById(roleId) {
    let ret = await httpClient.get(`roles/${roleId}`)
    return ret
  },
  async getUserById(userId) {
    let ret = await httpClient.get(`users/${userId}`)
    return ret
  },
  async getOrganizationRoles() {
    let ret = await httpClient.get('roles')
    return ret
  },
  async createRole(data) {
    let ret = await httpClient.post('roles', data)
    return ret
  },
  async updateOrganization(data) {
    let ret = await httpClient.put('organizations', data)
    return ret
  },
  async updateRole(roleId, data) {
    let ret = await httpClient.put(`roles/${roleId}`, data)
    return ret
  },
  async deleteRole(roleId) {
    let ret = await httpClient.delete(`roles/${roleId}`)
    return ret
  },
  async getLogs(query) {
    let ret = await httpClient.get('organizations/audit', {
      params: query,
    })
    return ret
  },
  async getLogsById(auditId) {
    let ret = await httpClient.get(`organizations/audit/${auditId}`)
    return ret
  },
}
